export default "__VITE_ASSET__HbDTXfHP__"